import { I18n } from '@calendly/i18n';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { IconButton } from '@calendly/ui/components/icon-button';
import { ArrowExpandIcon, AtmCardIcon, EditPencilIcon, MailSendEnvelopeIcon, MobilePhoneIcon, TimezoneIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { HeadlineText } from '@calendly/ui/components/typography';
import { colorIconStandard, colorTextAction } from '@calendly/ui/theme';
import { MeetingPackageContactRow } from './meeting_package_contact_row';
import { iconWrapperCss, Row } from './styles';
const arrowExpandIconCss = "anmz9iy";
export const ContactDetailRows = ({
  email,
  phoneNumber,
  timezone,
  paymentInfo,
  paymentLink,
  canEditEmail,
  openEditEmailModal,
  packageInfo,
  viewPackage
}) => <>
      <MeetingPackageContactRow packageInfo={packageInfo} viewPackage={viewPackage} />
      <Row>
        <span className={iconWrapperCss}>
          <MailSendEnvelopeIcon spacingRight={0} />
        </span>
        <FullStoryMask>{email}</FullStoryMask>
        {canEditEmail && <IconButton size="small" title={I18n.t('publisher.action.edit')} aria-label={I18n.t('publisher.action.edit')} onClick={openEditEmailModal}>
          <HeadlineText color={colorTextAction}>
            <EditPencilIcon />
          </HeadlineText>
        </IconButton>}
      </Row>
      {phoneNumber && <Row>
        <span className={iconWrapperCss}>
          <MobilePhoneIcon spacingRight={0} />
        </span>
        <FullStoryMask>{phoneNumber}</FullStoryMask>
      </Row>}
      {timezone && <Row>
        <span className={iconWrapperCss}>
          <TimezoneIcon spacingRight={0} />
        </span>
        <span>{timezone}</span>
      </Row>}
      {paymentInfo && <Row>
        <span className={iconWrapperCss}>
          <AtmCardIcon spacingRight={0} />
        </span>
        <FullStoryMask>{paymentInfo}</FullStoryMask>
        {paymentLink && <Link href={paymentLink} target="_blank" rel="noopener noreferrer" underline={false} className={arrowExpandIconCss}>
            <ArrowExpandIcon color={colorIconStandard} />
          </Link>}
      </Row>}
    </>;

require("./contact_detail_rows.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_detail_rows.js");